(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const initialize = (root) => {
    if (root.dataset.policyInitialized) return;
    const body = root.querySelector('[data-eco-policy-body] .shopify-policy__body');
    const details = root.querySelector('[data-policy-index]');
    const links = root.querySelector('[data-policy-links]');
    if (!body || !details || !links) return;
    const headings = [...body.querySelectorAll('h2,h3')].filter(heading => heading.textContent.trim());
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = 'eco-policy-heading-' + (index + 1);
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = heading.textContent.trim();
      if (heading.tagName === 'H3') link.dataset.subheading = '';
      links.append(link);
    });
    if (!headings.length) details.parentElement.hidden = true;
    const syncIndex = () => { details.open = desktop.matches; };
    syncIndex();
    desktop.addEventListener('change', syncIndex);
    const markCurrent = () => {
      links.querySelectorAll('a').forEach(link => {
        if (link.hash === window.location.hash) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    window.addEventListener('hashchange', markCurrent);
    links.addEventListener('click', event => {
      if (event.target.closest?.('a') && !desktop.matches) details.open = false;
    });
    markCurrent();
    root.dataset.policyInitialized = 'true';
  };
  const start = () => document.querySelectorAll('[data-eco-policy-guide]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
